import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Icon from 'lib/struct/icon/Icon';

import styles from './ShopPromoLabel.less'

@observer export default class ShopPromoLabel extends Component {
    render() {
        const {label, promo} = this.props

        return (
            <div className={styles['block']}>
                <div className={styles['label-block']}>
                    {label}
                </div>

                <div className={styles['links-block']}>
                    <a
                        href={promo.edit_url}
                        target="_blank"
                    >
                        <Icon name="settings"/> {promo.edit_label}
                    </a>

                    <a
                        href={promo.products_url}
                        target="_blank"
                    >
                        <Icon name="search"/> Смотреть товары
                    </a>
                </div>
            </div>
        )
    }
}